import { render, staticRenderFns } from "./BookingSettings.vue?vue&type=template&id=783c985c&scoped=true"
import script from "@/controllers/bookingSettings.js?vue&type=script&lang=js&external"
export * from "@/controllers/bookingSettings.js?vue&type=script&lang=js&external"
import style0 from "./BookingSettings.styles.scss?vue&type=style&index=0&id=783c985c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783c985c",
  null
  
)

export default component.exports